"use client"

import { useState } from "react"
import styles from "./SideDrawer.module.css"
import promoImg from "../../assets/images/change-gallery (3).png"
import footerImg from "../../assets/images/footer-whatasapp-doctors-2.png"
import instaIcon from "../../assets/images/insta-logo.png"

export default function SideDrawer({ open, onClose }) {
  const [treatmentsOpen, setTreatmentsOpen] = useState(false)

  const linksBeforeTreatments = [
    "Corporate",
    "Patient Guide",
  ]

  const linksAfterTreatments = [
    "F.A.Q",
    "Results",
    "Contact",
  ]

  const treatments = [
    { name: "DHI Hair Transplant", href: "/dhi-hair-transplant" },
    { name: "Sapphire FUE Hair Transplant", href: "/sapphire-fue-hair-transplant" },
    { name: "Autologous Micrograft", href: "/autologous-micrograft" },
    { name: "Rhinoplasty", href: "/rhinoplasty" },
  ]

  return (
    <>
      <div className={`${styles.drawer} ${open ? styles.drawerOpen : ""}`} aria-hidden={!open}>
        <div className={styles.drawerHeader}>
          <span></span>
          <button onClick={onClose} aria-label="Close" className={styles.closeBtn}>
            <span className={styles.closeBtnIcon} aria-hidden="true" />
          </button>
        </div>
        <div className={styles.drawerBody}>
          <div className={styles.leftCol}>
            <nav className={styles.linkList}>
              {linksBeforeTreatments.map((l) => {
                let href = "#"
                if (l === "Corporate") href = "/corporate"
                if (l === "Patient Guide") href = "/patient-guide"
                return (
                  <a href={href} key={l} className={styles.linkItem}>{l}</a>
                )
              })}
              
              <div className={styles.treatmentSection}>
                <button 
                  onClick={() => setTreatmentsOpen(!treatmentsOpen)} 
                  className={styles.treatmentToggle}
                >
                  <span>Our Treatments</span>
                  <span className={`${styles.arrow} ${treatmentsOpen ? styles.arrowOpen : ""}`}>▾</span>
                </button>
                {treatmentsOpen && (
                  <div className={styles.treatmentSubmenu}>
                    {treatments.map((t) => (
                      <a href={t.href} key={t.name} className={styles.treatmentLink}>
                        {t.name}
                      </a>
                    ))}
                  </div>
                )}
              </div>

              {linksAfterTreatments.map((l) => {
                let href = "#"
                if (l === "F.A.Q") href = "/faq"
                if (l === "Results") href = "/results"
                if (l === "Contact") href = "/contact"
                return (
                  <a href={href} key={l} className={styles.linkItem}>{l}</a>
                )
              })}
            </nav>

            <div className={styles.bottomLeft}>
              <div className={styles.follow}>Follow Us Social Media</div>
              <div className={styles.socialIcons}>
                <a href="https://instagram.com/estaverde_clinic" target="_blank" rel="noreferrer" aria-label="Instagram">
                  <img src={instaIcon} alt="Instagram" className={styles.instaIcon} />
                </a>
              </div>
            </div>
          </div>

          <div className={styles.rightCol}>
            <a href="/results" className={styles.promoImgLink}>
              <img src={promoImg} alt="All Results" className={styles.promoImg} />
            </a>
            <a href="https://wa.me/905337674950" target="_blank" rel="noreferrer">
              <img src={footerImg} alt="WhatsApp" className={styles.teamImg} />
            </a>
          </div>
        </div>
      </div>
      {open && <div className={styles.backdrop} onClick={onClose} aria-hidden="true" />}
    </>
  )
}
